import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftedgeComponent } from './simple-icons-microsoftedge.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftedgeComponent ],
    exports:      [ SimpleIconsMicrosoftedgeComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftedgeModule {}
